export default class FretboardConfig {
	title = "";
	fretboards = null;

	constructor(title, fretboards) {
		this.title = title;
		this.fretboards = fretboards;
	}
}
